import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import queryParser from './utils/queryParser';
import { removeHashUrl, saveHrefOnBrowserLoad, applyFaviconBasedOnBrandId } from './utils';
import configureStore from './store';
import { fetchConfig } from './infrastructure/config';
import { fetchContent } from './infrastructure/content';
import { deleteToken } from './infrastructure/token';
import { App } from './App';
import sessionUtils from './utils/sessionUtil';
import { ACCESS_TOKEN, BANK_ID, BRAND_ID, TYPE_KEY } from './utils/constants';
import sessionRedirectUtil from './utils/sessionRedirectUtils';
import * as analytics from './utils/analytics';
import { fromJS } from 'immutable';

const defaultBranding = () => import('web-ui-components/lib/app.vm.css');
const applyBranding = brandId =>
  brandId === 'CB'
    ? import('web-ui-components/lib/app.cb.css')
    : import('web-ui-components/lib/app.yb.css');

const parsedParams = queryParser();

const parseSearchParam = queryParser(window.location.search);

saveHrefOnBrowserLoad(window.location.href);
const store = configureStore({
  config: fromJS(parsedParams)
    .set(BRAND_ID, fromJS(parsedParams.get(BRAND_ID) ? parsedParams.get(BRAND_ID) : 'VM'))
    .set(TYPE_KEY, fromJS(parseSearchParam.get(TYPE_KEY) ? parseSearchParam.get(TYPE_KEY) : ''))
    .set(BANK_ID, fromJS(parsedParams.get(BANK_ID) ? parsedParams.get(BANK_ID) : null))
});

removeHashUrl(`${BRAND_ID}=${parsedParams.get(BRAND_ID) || 'VM'}`);

analytics.updateBrandName(parsedParams.get(BANK_ID));

if (parsedParams && parsedParams.toJS && parsedParams.toJS().business_type) {
  const businessType = decodeURIComponent(parsedParams.toJS().business_type);
  analytics.updateBusinessType(businessType);
}
analytics.updateApplicant();
if (parsedParams && parsedParams.toJS && parsedParams.toJS().linkCode) {
  const linkCode = decodeURIComponent(parsedParams.toJS().linkCode);
  analytics.updateApplicant(linkCode);
}

const onExpiry = () => {
  sessionUtils.clearTimeOut();

  const token = store.getState().config.get(ACCESS_TOKEN);
  const bankId = store.getState().config.get(BANK_ID);

  store.dispatch(deleteToken(token, bankId));
};

window.addEventListener('beforeunload', _event => {
  sessionRedirectUtil.onBrowserRefresh(store.getState());
});

const brandId = store.getState().config.get(BRAND_ID);
brandId !== 'VM' ? applyBranding(brandId) : defaultBranding();
applyFaviconBasedOnBrandId(brandId);

Promise.all([store.dispatch(fetchConfig()), store.dispatch(fetchContent())]).then(() => {
  sessionUtils.appSessionManagement(onExpiry);
  ReactDOM.render(
    <Provider store={store}>
      <WebUIThemeProvider brandID={brandId}>
        <App />
      </WebUIThemeProvider>
    </Provider>,
    document.getElementById('business-accounts-web-app')
  );
});
